/**
 * Trova le differenze tra due oggetti (utile per payload di update).
 * Confronta solo le chiavi presenti in 'modified'.
 * @param {object} original - L'oggetto originale.
 * @param {object} modified - L'oggetto modificato.
 * @returns {object} Un oggetto contenente solo le coppie chiave/valore che sono diverse.
 */
export const findDifferences = (original, modified) => {
  if (!original || !modified) return modified || {}; // Se uno è nullo, ritorna l'altro o vuoto

  const differences = {};

  Object.keys(modified).forEach(key => {
    // Confronto semplice, potrebbe non funzionare bene per oggetti/array annidati
    // Considera una libreria come lodash.isEqual per confronti profondi se necessario
    if (original[key] !== modified[key]) {
      differences[key] = modified[key]; // Includi solo il valore modificato
    }
  });

  return differences;
};

/**
 * Determina il tipo di input HTML appropriato per un campo, basandosi su nome,
 * configurazione specifica (inputTypes), e presenza di lookup options.
 * @param {string} fieldName - Il nome del campo (es. 'FUA_CodiceFunzione').
 * @param {object} inputTypesConfig - Oggetto di configurazione { fieldName: 'type' } (es. { 'descrizione': 'textarea' }).
 * @param {object} lookupOptions - Oggetto con le opzioni lookup { fieldName: [...] }.
 * @returns {string} Il tipo di input suggerito (es. 'text', 'number', 'select', 'date', 'boolean', 'textarea').
 */
export const getInputType = (fieldName, inputTypesConfig = {}, lookupOptions = {}) => {
  // 1. Priorità alla configurazione esplicita in inputTypesConfig
  if (inputTypesConfig[fieldName]) {
    return inputTypesConfig[fieldName];
  }

  // 2. Se ci sono lookup options per questo campo, è un 'select'
  if (lookupOptions[fieldName] && Array.isArray(lookupOptions[fieldName])) {
    return 'select';
  }

  // 3. Inferenza basata sul nome del campo (euristiche comuni)
  const lowerFieldName = fieldName.toLowerCase();
  if (lowerFieldName.includes('password')) return 'password';
  if (lowerFieldName.includes('email')) return 'email';
  if (lowerFieldName.includes('data') || lowerFieldName.includes('date')) return 'date';
  // Potresti voler essere più specifico per 'datetime-local', 'time', 'month', 'week'
  if (lowerFieldName.includes('numero') || lowerFieldName.includes('importo') || lowerFieldName.includes('quantita') || lowerFieldName.endsWith('_id') || lowerFieldName.endsWith('id') || lowerFieldName.includes('_nr') || lowerFieldName.includes('progressivo')) return 'number';
  if (lowerFieldName.startsWith('is_') || lowerFieldName.startsWith('fl_') || lowerFieldName.includes('flag')) return 'boolean'; // O 'checkbox'/'toggle'

  // 4. Default a 'text'
  return 'text';
};

// Potresti aggiungere altre utility qui se necessario, ad esempio:
// - formatDataForDisplay(value, type)
// - parseValueForApi(value, type)